module.exports = __webpack_public_path__ + "static/img/11.b97b9e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/11.png
// module id = so9s
// module chunks = 0